import React from 'react';

import { Link } from 'react-router';

import { t } from 'i18next';

import { SidebarItem, Text } from '@datanomik/core-ui';

export type SettingsModuleItem = {
  key: string;
  label: string;
  icon?: React.ReactNode;
  to: string;
};

type Props = {
  items: SettingsModuleItem[];
  currentTab: string;
  menuLabel?: string;
};

const isItemSelected = (currentTab: string, to: string) => (
  currentTab === to || currentTab.startsWith(`${to}/`)
);

const SettingsModulesSidebar: React.FC<Props> = ({
  items, currentTab, menuLabel = 'Settings',
}) => (
  <div className="w-66 shrink-0 sticky top-23 self-start max-h-[calc(100vh_-_92px_-_24px)] overflow-y-auto">
    <div className="rounded-xl bg-card p-[16px_12px]">
      <Text variant="micro" weight="medium" tone="muted" style={{
        textTransform: 'uppercase',
        paddingLeft: '12px',
        paddingRight: '12px',
        marginBottom: '8px',
      }}>
        {t(menuLabel)}
      </Text>

      <div className="flex flex-col gap-[2px]">
        {items.map((item) => {
          const selected = isItemSelected(currentTab, item.to);

          return (
            <SidebarItem
              key={item.key}
              as={Link}
              to={item.to}
              icon={item.icon}
              active={selected}
            >
              {t(item.label)}
            </SidebarItem>
          );
        })}
      </div>
    </div>
  </div>
);

export default SettingsModulesSidebar;
